export default "__VITE_ASSET__CER2E_mY__"